import { ProdutoVariacaoValorStruct } from "../../structs/produto/produto-variacao-valor.struct";

export class CombinacaoVariacaoRequest {
  codigoSkuPai: string | null;
  listVariacoes: ProdutoVariacaoValorStruct[] = [];
}